export const FailedUserFetchResponse =
  "Unable to fetch users. Please Try again!";
export const FailedcustomerTagResponse =
  "Unable to fetch customer Tag. Please Try again";
export const FailedToFetchUserResponse =
  "Unable to fetch user details. Please Try again!";
export const SuccessUserEditResponse = "updated sucessfully!";
export const failedToUpdateuser = "Failed to update ";
